import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { BASE_URL, OG_IMAGE } from '../utils/seo';
import { enterUp } from '../utils/animations';
import { TermsContent } from '../components/terms/TermsContent';

export default function TermsOfService() {
    return (
        <div data-testid="terms-of-service-page">
            <Helmet>
                <title>Terms of Service - White Glove Hiring</title>
                <meta name="description" content="Terms of Service for whiteglovehiring.com, operated by White Glove Hiring, LLC. The terms that govern your use of our website and services." />
                <meta property="og:title" content="Terms of Service - White Glove Hiring" />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={`${BASE_URL}/terms-of-service`} />
                <meta property="og:image" content={OG_IMAGE} />
                <link rel="canonical" href={`${BASE_URL}/terms-of-service`} />
            </Helmet>

            <section className="bg-navy-900 hero-pattern pt-36 pb-20">
                <div className="max-w-7xl mx-auto px-6 lg:px-12">
                    <motion.div {...enterUp}>
                        <p className="text-gold-400 text-xs font-bold tracking-[0.3em] uppercase font-inter mb-4">Legal</p>
                        <h1 className="font-montserrat font-black text-5xl md:text-6xl text-white tracking-tight leading-tight">
                            Terms of Service
                        </h1>
                        <p className="text-gray-300 text-lg mt-5">Last updated: September 24, 2026</p>
                    </motion.div>
                </div>
            </section>

            <TermsContent />
        </div>
    );
}
